// src/App.js
import React, { useEffect, useState } from 'react';
import './App.css';
import PCStatus from './PCStatus';
import './responsive_style.css';

function App() {
  const [isNight, setIsNight] = useState(false);

  useEffect(() => {
    const checkMode = () => {
      const now = new Date();
      const minutes = now.getHours() * 60 + now.getMinutes();
      const night = minutes >= 1170 || minutes < 480; // 19h30 = 1170, 8h00 = 480
      setIsNight(night);
    };

    checkMode();
    const interval = setInterval(checkMode, 60000); // vérifie chaque minute
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isNight) {
      document.body.classList.add('night-mode');
      document.body.classList.remove('day-mode');
    } else {
      document.body.classList.add('day-mode');
      document.body.classList.remove('night-mode');
    }
  }, [isNight]);

  return (
    <div className="App">
      <header className="App-header">
        <div><h1>Monitoring IP & Services</h1></div>
        <div><h2>Made with ❤️ by Mika</h2></div>
      </header>
      <main>
        <PCStatus />
      </main>
    </div>
  );
}

export default App;
